module.exports = __webpack_public_path__ + "img/crm.14be794b.svg";